module.exports = "<artbycoloring-canvas></artbycoloring-canvas>\r\n"